module.exports = __webpack_public_path__ + "static/media/logo.a76c464b.svg";